"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthLink = exports.AuthLinkType = exports.AuthChain = void 0;
const schemas_1 = require("@dcl/schemas");
Object.defineProperty(exports, "AuthChain", { enumerable: true, get: function () { return schemas_1.AuthChain; } });
Object.defineProperty(exports, "AuthLinkType", { enumerable: true, get: function () { return schemas_1.AuthLinkType; } });
Object.defineProperty(exports, "AuthLink", { enumerable: true, get: function () { return schemas_1.AuthLink; } });
//# sourceMappingURL=types.js.map